import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "authentication-view" }
const _hoisted_2 = { style: {"position":"relative"} }
const _hoisted_3 = { style: {"margin-bottom":"30px","display":"flex","align-items":"center","justify-content":"center"} }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", {
  class: "secondary-text",
  style: {"margin":"0 10px"}
}, "|", -1)

import {computed, defineComponent, Ref, ref, unref} from "vue";
import {UIHandleGet} from "@/views/utils";
import UserAPI from "@/api/UserAPI";
import {setAccessToken} from "@/store";
import {useRouter} from "vue-router";
import {store, loginViewShow} from "@/store";
import {FormInstance, FormRules} from "element-plus";
import {Close} from "@element-plus/icons-vue";
import Login from "./Login.vue"
import Register from "@/views/user/Register.vue";


export type Form = {
  loginName: string,
  // 密码登录需要
  password: string,
  // 验证码登录需要
  code: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Authentication',
  props: {
  redirect: {
    type: String,
    required: false
  }
},
  setup(__props) {

const props = __props




const menuLoginByTel = "loginByTel"
const menuRegisterByTel = "registerByTel"
const menuType = ref<string>(menuLoginByTel)

const {redirect = "/"} = props
let form = ref<Form>({
  loginName: "",
  password: "",
  code: ""
})
const formEle = ref<FormInstance | null>(null)

// 规则
const rules = computed(() => {

  let rules: FormRules = {
    loginName: {
      required: true,
      message: "电话没有填写",
      trigger: "blur"
    }
  }

  if (menuType.value === 'tel_password') {
    Object.assign(rules, {
      password: {
        required: true,
        message: "密码没有填写",
        trigger: "blur"
      }
    })
  } else if (menuType.value === 'tel_code') {
    Object.assign(rules, {
      password: {
        required: true,
        message: "验证码没有填写",
        trigger: "blur"
      }
    })
  }

  return rules
})

const {login, loading} = useLogin(form, redirect)
const sendCodeLeftSeconds = ref<number>(0)
const sendCode = () => {
  //....send code
  sendCodeLeftSeconds.value = 10
  let interval = setInterval(() => {
    sendCodeLeftSeconds.value = sendCodeLeftSeconds.value - 1
    if (sendCodeLeftSeconds.value === 0) {
      clearInterval(interval)
    }
  }, 1000)
}

function useLogin(formRef: Ref<Form>, redirect: string) {
  const loading = ref(false)
  let router = useRouter()
  const login = async () => {

    await formEle.value!.validate()

    try {
      loading.value = true
      let form = unref(formRef)

      let result: any

      if (menuType.value === 'tel_password') {
        let data: any = {
          tel: form.loginName,
          password: form.password
        }
        result = await UIHandleGet(UserAPI.loginByTelAndPassword(data))
      } else if (menuType.value === 'tel_code') {
        let data: any = {
          tel: form.loginName,
          password: form.code
        }
        result = await UIHandleGet(UserAPI.loginByTelAndCode(data))
      }

      setAccessToken(result.accessToken, result.id)
      location.reload()

    } catch (e) {
      console.error(e)
    } finally {
      loading.value = false
    }
  }

  return {
    login,
    loading
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_dialog, {
      modelValue: _unref(loginViewShow),
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(loginViewShow) ? (loginViewShow).value = $event : null)),
      width: "400px"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (loginViewShow.value = false)),
            style: {"position":"absolute","right":"-10px","top":"-20px","cursor":"pointer"}
          }, [
            _createVNode(_component_el_icon, null, {
              default: _withCtx(() => [
                _createVNode(_unref(Close))
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (menuType.value = menuLoginByTel)),
              class: _normalizeClass(["login-way", {'login-way-active': menuType.value === menuLoginByTel}])
            }, "登录", 2),
            _hoisted_4,
            _createElementVNode("span", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (menuType.value = menuRegisterByTel)),
              class: _normalizeClass(["login-way", {'login-way-active': menuType.value === menuRegisterByTel}])
            }, " 注册 ", 2)
          ]),
          (menuType.value === menuLoginByTel)
            ? (_openBlock(), _createBlock(Login, { key: 0 }))
            : _createCommentVNode("", true),
          (menuType.value === menuRegisterByTel)
            ? (_openBlock(), _createBlock(Register, { key: 1 }))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})